<template>
  <div>
    <div class="icon__bg-circle"
         :class="{'icon__bg-circle--active': isPrioritizerActive}"
         @click="setIsPrioritizerActive(true)"
         :content="$t('vue2.sub_scheduler.set_priorities')"
         v-tippy="{
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window'
              }">
      <span class="icon-cog2"></span>
    </div>
    <transition name="fadeInLeft">
      <div class="sub-scheduler__filters__subzen__priorities" v-if="isPrioritizerActive">
        <div class="sub-scheduler__filters__subzen__priorities__header">
          <h3>
            {{ $t('vue2.sub_scheduler.set_priorities') }}
          </h3>
          <div class="icon__bg-circle sub-scheduler__filters__subzen__priorities__close"
               @click="setIsPrioritizerActive(false)">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="pad-10-bottom" v-if="isEditable">
          <draggable v-model="list" @change="onChange">
            <transition-group type="transition" name="flip-list">
              <div v-for="(element, key) in list"
                   :key="element[0]"
                   class="sub-scheduler__filters__subzen__priorities__priority">
                <div class="sub-scheduler__filters__subzen__priorities__priority__number">{{ key + 1 }}</div>
                <p>{{ getItemTitle(element[0]) }}</p>
              </div>
            </transition-group>
          </draggable>
        </div>
        <ul class="border-1-top sub-scheduler__unAvailableItems">
          <li v-for="(item, key) in unAvailableItems"
              class="sub-scheduler__filters__subzen__priorities__priority sub-scheduler__filters__subzen__priorities__priority--not-moveable">
            <div class="sub-scheduler__filters__subzen__priorities__priority__number">{{ list.length + 1 + key }}</div>
            <p>{{ getItemTitle(item[0]) }}</p>
          </li>
        </ul>
        <div class="sub-scheduler__filters__subzen__priorities__footer pad-10-bottom">
          <button @click="isPrioritizerActive = false">{{ $t('vue2.presence.cancel') }}</button>
          <button class="bttn bttn-primary marg-10-left" :class="{'bttn-primary--disabled': !isChangeHasBeenMade}"
                  @click="onSave">{{ $t('vue2.presence.save') }}
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  props: {
    propsIsPrioritizerActive: {
      default: false
    }
  },
  watch: {
    propsIsPrioritizerActive (val) {
      this.setIsPrioritizerActive(val)
    }
  },
  data () {
    return {
      isPrioritizerActive: false,
      isEditable: true,
      isChangeHasBeenMade: false,
      list: [],
      translations: {
        canceledHours: this.$t('vue2.sub_scheduler.has_canceled_hours'),
        othersOnLesson: this.$t('vue2.sub_scheduler.already_on_lesson'),
        isInSameClassAtTheSameTime: this.$t('vue2.sub_scheduler.is_in_same_class_at_the_same_time'),
        hasHoursInClassOnDay: this.$t('vue2.sub_scheduler.has_hours_in_class_on_day'),
        multipleLessonsInSameClasses: this.$t('vue2.sub_scheduler.multiple_lessons_in_same_classes'),
        availableHour: this.$t('vue2.sub_scheduler.not_occupied_with_available_lesson'),
        presence: this.$t('vue2.sub_scheduler.not_occupied_with_work_hours'),
        notOccupiedWithLessonsOnDay: this.$t('vue2.sub_scheduler.not_occupied_without_work_hours'),
        severalOnALesson: this.$t('vue2.sub_scheduler.multiple_on_a_lesson'),
        notOccupiedWithoutLessonsOnDay: this.$t('vue2.sub_scheduler.not_occupied_without_lessons_on_the_day'),
        occupied: this.$t('vue2.sub_scheduler.occupied'),
        absence: this.$t('vue2.sub_scheduler.absent_people')
      }
    }
  },
  computed: {
    dragOptions () {
      return {
        animation: 0,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    storeSorting () {
      return this.$store.state.subs.sortingHierarchy
    },
    sortingHierarchy () {
      return Object.entries(this.storeSorting).sort((a, b) => {
        return a[1] - b[1]
      })
    },
    updatedList () {
      return this.list.map((item, idx) => {
        return {
          name: item[0], value: idx * 3
        }
      })
    },
    unAvailableItems () {
      return [
        ['notOccupiedWithoutLessonsOnDay', this.storeSorting.notOccupiedWithoutLessonsOnDay],
        ['occupied', this.storeSorting.occupied]
      ]
    }
  },
  methods: {
    setIsPrioritizerActive (boolean) {
      if (boolean) {
        this.list = this.sortingHierarchy.filter(item => item[0] !== 'absence' && item[0] !== 'occupied' && item[0] !== 'notOccupiedWithoutLessonsOnDay')
        this.isPrioritizerActive = true
        this.isChangeHasBeenMade = false
      } else {
        this.isPrioritizerActive = false
      }
      this.$emit('setIsPrioritizerActive', this.isPrioritizerActive)
    },
    getItemTitle (item) {
      return this.translations[item] ? this.translations[item] : 'No title'
    },
    removeActiveEvent () {
      this.$store.commit('setActiveUser', null)
      this.$store.commit('setActiveEvent', null)
      this.$store.dispatch('setActiveSchedulerEvent', {
        'left': -10,
        'right': -10,
        'color': '',
        'oldSubScoreMeta': [],
        'obj': null
      })
    },
    onChange () {
      this.isChangeHasBeenMade = true
    },
    onSave () {
      if (!this.isChangeHasBeenMade) {
        return
      }
      let updatedObj = this.updatedList.reduce((obj, item) => Object.assign(obj, {[item.name]: item.value}), {})
      this.$store.dispatch('updateSortingHierarchy', updatedObj)
      this.removeActiveEvent()
      this.setIsPrioritizerActive(false)
    }
  }
}
</script>

<style>

.sub-scheduler__filters__subzen__priorities {
  position: absolute;
  top: 0px;
  user-select: none;
  left: calc(100% - 10px);
  background-color: #edf0f5;
  padding: 10px 20px;
  z-index: 10000;
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -7px rgba(0, 0, 0, 0.2);
  width: 300px;
  transition: all 0.2s;
}

.sub-scheduler__filters__subzen__priorities__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d8d8d8;
  margin-bottom: 10px;
}

.sub-scheduler__filters__subzen__priorities__close {
  font-size: 2rem;
}

.sub-scheduler__filters__subzen__priorities__priority {
  border-radius: 4px;
  margin-bottom: 5px;
  cursor: move;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 5px 0;
  transition: transform 0.25s, background-color 0.25s, box-shadow 0.25s;
  display: flex;
  align-items: stretch;
  font-weight: normal;
  border: 1px solid transparent;
}

.sub-scheduler__filters__subzen__priorities__priority:hover {
  background-color: #F9FAFC;
  transform: translateY(-2px);
}

.sub-scheduler__filters__subzen__priorities__priority.sub-scheduler__filters__subzen__priorities__priority--not-moveable {
  box-shadow: none;
  background-color: transparent !important;
  border-color: #CCCCCC;
  transform: translateY(0) !important;
  cursor: default;
  opacity: 0.8;
}

.sub-scheduler__filters__subzen__priorities__priority__number {
  padding: 5px 10px;
  background: #f6f7f8;
  margin-right: 10px;
  border-radius: 4px 0 0 4px;
  display: flex;
  align-items: center;
}

.sub-scheduler__filters__subzen__priorities__priority > p {
  flex: 1;
  display: flex;
  align-items: center;
  line-height: 1.2rem;
  padding: 10px;
}

.sub-scheduler__filters__subzen__priorities:before {
  right: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(194, 225, 245, 0);
  border-right-color: #edf0f5;
  border-width: 10px;
  margin-top: 0px;
  top: 10px;
}

.sub-scheduler__filters__subzen__priorities__footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.sub-scheduler__filters__subzen__priorities__footer .bttn-primary {
  box-shadow: 0 2px 2px rgba(0, 0, 0, .1);
  transition: transform 0.5s, box-shadow 0.5s;
  transform: scale(1);
}

.sub-scheduler__filters__subzen__priorities__footer .bttn-primary.bttn-primary--disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
  transform: scale(0.9);
}

.sub-scheduler__filters__subzen:hover > .sub-scheduler__filters__subzen__priorities {
  visibility: visible;
  opacity: 1;
  transform: translateX(0);
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.sortable-ghost {
  opacity: 0.5;
  background: #e9ecef;
}

.list-group-item i {
  cursor: pointer;
}

.sub-scheduler__unAvailableItems {
  padding: 10px 0;
}

.icon__bg-circle.icon__bg-circle--active {
  background-color: rgba(0, 0, 0, .16);
}
</style>



// WEBPACK FOOTER //
// SchedulerPrioritizer.vue?eade744e